// extracted by mini-css-extract-plugin
export default {"star":"star-rating_star__aQ-x7","input":"star-rating_input__E8GJV","container":"star-rating_container__Ri-Ii"};